export enum PaymentProcessorAlias {
    WORLDPAYXML = 'WPXML',
    PAYVISION = 'PV',
    WPAY = 'WP',
    NETWORKINTERNATIONAL = 'NG',
    NEXIO = 'NEXIO',
    PAYPAL = 'PAYPAL',
    eCheck = 'eCheck',
    ADYEN = 'ADYEN',
    NI = 'NI',
    WPAYXML = 'WPAYXML'
}



// WEBPACK FOOTER //
// ./src/app/customerservice/enums/payment-processor-alias.enum.ts